import { currentTheme } from '../themes/useTheme';

// Colours for the Reading page's inline styles and Chart.js options (canvas can't use CSS variables).
const paper = currentTheme() === 'paper';

const C = paper
  ? {
      text: '#1d1a16', muted: 'rgba(29, 26, 22, 0.8)', dim: 'rgba(29, 26, 22, 0.72)',
      grid: 'rgba(29, 26, 22, 0.12)', line: 'rgba(29, 26, 22, 0.35)', hover: 'rgba(29, 26, 22, 0.06)',
      empty: 'rgba(29, 26, 22, 0.08)', panel: 'transparent', panel2: 'rgba(29, 26, 22, 0.05)',
      btn: 'rgba(246, 240, 226, 0.9)', btnHover: '#f6f0e2', accent: '#1d1a16', accentBg: 'rgba(29, 26, 22, 0.08)',
      glow: '0 0 0 2px #1d1a16', activeBg: '#1d1a16', activeFg: '#f6f0e2',
      green: '#1f5a23', blue: '#164a7e', orange: '#7a4300', purple: '#5a1868', red: '#8f2018', pink: '#85123d', amber: '#5e4800',
      lightGreen: '#3b5214', lime: '#464f08', indigo: '#3d2377', deepOrange: '#8a2a08', greenHi: '#2e7a33', blueHi: '#1f62a0', fallback: '#4a3f30',
      // heatmap ramp, pale -> dark ink (hex: some callers append an alpha suffix)
      r0: '#d8cdb4', r1: '#b9a98a', r2: '#8f7d5e', r3: '#6a5a43', r4: '#443a2c', r5: '#1d1a16', r6: '#7a6a50',
    }
  : {
      text: '#ddd', muted: '#aaa', dim: '#999',
      grid: 'rgba(255, 255, 255, 0.1)', line: 'rgba(255, 255, 255, 0.2)', hover: 'rgba(255, 255, 255, 0.05)',
      empty: '#2a2a2a', panel: 'rgba(0, 0, 0, 0.4)', panel2: 'rgba(0, 0, 0, 0.2)',
      btn: 'rgba(0, 0, 0, 0.7)', btnHover: 'rgba(0, 0, 0, 0.9)', accent: '#007bff', accentBg: 'rgba(0, 123, 255, 0.1)',
      glow: '0 0 8px rgba(255,255,255,0.5)', activeBg: '#4CAF50', activeFg: '#fff',
      green: '#4CAF50', blue: '#2196F3', orange: '#FF9800', purple: '#9C27B0', red: '#F44336', pink: '#E91E63', amber: '#FFC107',
      lightGreen: '#8BC34A', lime: '#CDDC39', indigo: '#673AB7', deepOrange: '#FF5722', greenHi: '#66BB6A', blueHi: '#42A5F5', fallback: '#666',
      r0: '#6495ED', r1: '#9370DB', r2: '#BA55D3', r3: '#FF69B4', r4: '#FF6347', r5: '#FF4500', r6: '#DA70D6',
    };

// categorical colours for lists of items (bursts, circadian hours...)
C.series = [C.deepOrange, C.red, C.pink, C.purple, C.indigo];
C.series10 = [C.green, C.lightGreen, C.lime, C.amber, C.orange, C.deepOrange, C.red, C.pink, C.purple, C.indigo];

export default C;
